import { gsap, ScrollTrigger } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger)

export function fadeInUp(
  element: HTMLElement,
  scrolltriggerAttributes?: { trigger?: HTMLElement; start?: string; end?: string; markers?: boolean }
) {
  const parentSection = element.closest('section')
  const { trigger, start, end, markers } = scrolltriggerAttributes || {}
  let mm = gsap.matchMedia()

  mm.add('(min-width: 992px)', () => {
    gsap.set(element, { yPercent: 15, opacity: 0 })

    const fadeinUp = gsap
      .timeline({
        scrollTrigger: {
          trigger: trigger ? trigger : parentSection,
          start: start || 'top center',
          end: end || 'center center',
          invalidateOnRefresh: true,
          markers: markers || false
        }
      })
      .to(element, {
        yPercent: 0,
        opacity: 1,
        ease: 'linear',
        duration: 0.6
      })
  })
}
